import { useTranslation } from 'react-i18next';

import { ConservationBenchmarkType, TrendLabel } from '@/api/rest/resources/conservation';
import { getDisplayNumber } from '@/hooks/useDisplayNumber';
import { isNullish } from '@/utils/booleans';

export type GetExplainerTextParams = {
  benchmark?: {
    label: ConservationBenchmarkType | null;
    value: number;
  };
  trend?: {
    label: TrendLabel | null;
    value: number;
  };
  indicator:
    | 'ecologicalIntegrity'
    | 'habitatIntactness'
    | 'indicatorSpecies'
    | 'degradationDrivers'
    | 'speciesOccupancy';
};

export const useGetExplainerFallbackText = ({
  benchmark,
  trend,
  indicator,
}: GetExplainerTextParams): {
  benchmarkText: string | null;
  trendText: string | null;
} => {
  const { t } = useTranslation();
  const TREND_LABEL_UNIT = t('global.ui.unit.%');

  const benchmarkText =
    benchmark?.label && !isNullish(benchmark?.value)
      ? t(`shared.projects.project.conservation.explainers.${indicator}.benchmark.${benchmark.label}`, '', {
          value: getDisplayNumber(benchmark.value, undefined, {
            signDisplay: 'never',
          }),
        })
      : null;

  const trendText =
    trend?.label && !isNullish(trend?.value)
      ? t(`shared.projects.project.conservation.explainers.${indicator}.trendLabel.${trend.label}`, '', {
          value: `${getDisplayNumber(trend.value, undefined, {
            signDisplay: 'always',
          })}${TREND_LABEL_UNIT}`,
        })
      : null;

  return { benchmarkText: benchmarkText ?? null, trendText: trendText ?? null };
};
